import Client from '../HttpClient';

const groups = () => {
	return Client.get('/admin/api/instruction-link/item-groups');
};

const list = (code) => {
	return Client.get(`/admin/api/instruction-link/${code}`);
};

const update = (payload) => {
	return Client.put(`/admin/api/instruction-link`, payload);
};

const listRelations = (code) => {
	return Client.get(`/admin/api/menu-link-relation/${code}`);
};

const updateRelations = (code, payload) => {
	return Client.put(`/admin/api/menu-link-relation/${code}`, payload);
};

export default {
	groups,
	list,
	update,
	listRelations,
	updateRelations,
};
